export default function(x) {
  return +x;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-svg-legend/~/d3-scale/src/number.js
// module id = eqH6
// module chunks = 0